import { createTheme, globalTheme } from '@clds/component-theme';

const { spacing, palette, font } = globalTheme;

export const t = createTheme({
  code: {
    selection: palette.primary,
    padding: spacing.xs,
    fontSize: font.size.xxs,
    lineHeight: font.size.xs,
    syntax: {
      background: palette.surfaceAlt,
      attributeName: palette.code.accent1,
      attributeValue: palette.code.accent2,
      character: palette.code.accent3,
      comment: palette.code.accent4,
      keyword: palette.code.accent5,
      number: palette.code.accent6,
      operator: palette.code.accent7,
      regex: palette.code.accent8,
      tag: palette.code.accent9,
    },
  },
  header: {
    sizeVariant: {
      sm: { typographySize: 'xs', buttonSize: 'sm' },
      md: { typographySize: 'sm', buttonSize: 'md' },
    },
  },
});

export default t;
